export const WM_COLUMN_KEY_POSITION = 'position'
export const WM_COLUMN_KEY_TITLE = 'title'
export const WM_COLUMN_KEY_AUTHORS = 'authors'
export const WM_COLUMN_KEY_RELEASE_DATE = 'parution_date'
export const WM_COLUMN_KEY_SEGMENT1 = 'clil1'
export const WM_COLUMN_KEY_SEGMENT2 = 'clil2'
export const WM_COLUMN_KEY_POPULARITY = 'popularity'
export const WM_COLUMN_KEY_PROXIMITY_PERCENTAGE = 'distance'
